import axios from "../../../axios";

export const getAboutUs = () => {
  const response = axios.get(`cms/about-us-info/`);
  return response;
};

export const getFaq = () => {
  const response = axios.get(`cms/faqs/`);
  return response;
};
